import { useCallback } from 'react'

import { noop } from 'lodash'

import api from 'common/api'
import { useIsAuthed } from 'components/AuthShield'

import { SCID_MATCH, TAG } from '../constants'

interface IPayload {
  Label?: string
  Type?: string
  Scid?: string | number
}

const saveSearchHistory = ({ Label, Scid }: IPayload) => {
  const payload: IPayload = {}
  if (Scid) {
    payload.Scid = Scid
    payload.Type = SCID_MATCH
  } else {
    payload.Label = Label
    payload.Type = TAG
  }
  return api.post(`/api/historical_search`, payload).catch(noop)
}

export const useOnSaveSearchHistory = (payload: IPayload) => {
  const isAuthed = useIsAuthed()

  const onSaveSearchHistory = useCallback(() => {
    return isAuthed ? saveSearchHistory(payload) : noop
  }, [isAuthed, payload])

  return onSaveSearchHistory
}
